export default {
  en: {
    termsAndConditions: 'Terms & Conditions',
    editTermsAndConditions: 'Edit Terms & Conditions',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    newTermsAndConditions: 'Add Terms & Conditions',
    saveChange: 'Save Changes',
    cancel: 'Cancel',
    saveSuccessTitle: 'Success',
    saveSuccessMessage: 'Save Terms & Condition Success',
    confirmDeleteTitle: 'Confirm',
    confirmMessage: 'Confirm to remove <strong style="text-transform: uppercase">{title}</strong>?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel'
  },
  th: {
    termsAndConditions: 'ข้อตกลงและเงื่อนไข',
    editTermsAndConditions: 'แก้ไขข้อตกลงและเงื่อนไข',
    moveUp: 'เลื่อนขึ้น',
    moveDown: 'เลื่อนลง',
    newTermsAndConditions: 'เพิ่มรายการ',
    saveChange: 'บันทึก',
    cancel: 'ยกเลิก',
    saveSuccessTitle: 'สำเร็จ',
    saveSuccessMessage: 'แก้ไขข้อตกลงและเงื่อนไขสำเร็จ',
    confirmDeleteTitle: 'ยืนยัน',
    confirmMessage: 'กรุณายืนการลบ <strong style="text-transform: uppercase">{title}</strong>',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก'
  }
}
